import type { LevelConfig } from '../index';

export const boss1: LevelConfig = {
  id: 'boss_1',
  stage: '2',
  mapId: 'boss_arena',
  timeLimitSec: 300,
  playerSpawn: { x: 768, y: 768 },
  objective: { type: 'neutralize_targets', target: 1 },
  enemies: [
    // Minions spawned by boss phases
  ],
  loot: [],
  startingWeapon: 'RIFLE',
  startingAmmo: 5,
  unlocks: [],
};
